import { InputProps } from '@chakra-ui/react';
import React from 'react';

import {
  CmBox,
  CmFlex,
  CmFormControl,
  CmFormLabel,
} from '@/components/uiParts';

import { CmInput } from './CmInput';

type Props = {
  fontWeight?: 'normal' | 'bold';
  isRequired?: boolean;
  label: string;
  id?: string;
  inputWidth?: string;
  labelWidth?: string;
} & InputProps;

export const CmLabelAndHorizonInput: React.FC<Props> = ({
  isRequired = false,
  labelWidth,
  isInvalid,
  children,
  placeholder,
  id = '',
  label,
  value = '',
  width = '100%',
  inputWidth = '100%',
  onChange,
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFlex>
        <CmFormLabel
          minWidth={labelWidth}
          htmlFor={id}
          mb={0}
          {...{ isRequired }}
          mt="7px"
        >
          {label}
        </CmFormLabel>
        <CmBox flexGrow={1} ml={3}>
          <CmInput
            width={inputWidth}
            {...{ id, value, onChange, placeholder }}
          />
          {children}
        </CmBox>
      </CmFlex>
    </CmFormControl>
  );
};
